"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateUserInvitationRequest = void 0;
const zod_1 = require("zod");
exports.CreateUserInvitationRequest = zod_1.z.object({
    email: zod_1.z.string(),
    userPermissionId: zod_1.z.string(),
});
